<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Governing Body" :links="[{title:'Home', url:'/'},{title:'Governing Body'}]"></page-header>
      <section class="section">
        <div class="container1">
          <div class="heading-black1">Governing Body</div>
          <committee-component :members="members"></committee-component>
        </div>
      </section>
      <programmes></programmes>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>

import NavbarComponent from "../../components/Navbar.vue";
import FooterComponent from "../../components/Footer.vue";
import PageHeader from "../../components/PageHeader";
import Programmes from "@/views/about/Programmes";
import CommitteeComponent from "@/components/CommitteeComponent";

export default {
  name: "GoverningBody",
  components: {
    Programmes,
    NavbarComponent,
    PageHeader,
    FooterComponent,
    CommitteeComponent
  },
  data() {
    return {
      members: [
        {
          name: 'Hon. Narendra Bhikaji Darade',
          designation: 'President',
        },
        {
          name: 'Mr. Meena Kishor Darade',
          designation: 'Vice President'
        },
        {
          name: 'Mr. Laxman Bhikaji Darade',
          designation: 'Secretary'
        },
        {
          name: 'Mr. Ramdas Bhikaji Darade',
          designation: 'Treasury'
        },
        {
          name: 'Mr. Kishor Bhikaji Darade',
          designation: 'Director'
        },
        {
          name: 'Mr. Kunal Narendra Darade',
          designation: 'Director'
        },
        {
          name: 'Mrs. Surekha Narendra Darade',
          designation: 'Director'
        }, {
          name: 'Mr. Devidas Ramdas Darade',
          designation: 'Director'
        }, {
          name: 'Mrs. Shobha Shantaram Avhad',
          designation: 'Director'
        }, {
          name: 'Mr. Rupesh Laxman Darade',
          designation: 'Director'
        }, {
          name: 'Mr. Shubham Kishor Darade',
          designation: 'Director'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped/>

